import { Cornerstone } from '@rpi/api';
import { useTranslation } from '@rpi/i18n';

const useGetProductInformation = (sku: string) => {
  const {
    data: productRulesResponse,
    status,
    isLoading,
    isRefetching,
    isError,
  } = Cornerstone.useGetProductRules();

  const productMap: {
    [key: string]: string;
  } = {};

  if (isLoading || isRefetching || isError) {
    return {
      status,
      data: productMap,
    };
  }

  const productSkuSplit = sku.split('-');
  const productClass = productSkuSplit[0];
  const productOptions = productRulesResponse.data.productClasses;
  const productOptionsBasedOnClass = productOptions?.find(
    (product: any) => product.productClass === productClass,
  );
  const skuOptions = productOptionsBasedOnClass?.skuOptions;
  const skuOptionsArray = skuOptions?.map((item: any) => item.option);

  if (skuOptionsArray) {
    skuOptionsArray.reduce((details, key, index) => {
      details[key] = productSkuSplit[index + 1] ?? 'NA';
      return details;
    }, productMap);
  }

  return { status, data: productMap, productClass };
};

export const useProductDetails = (sku: string) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.product' });

  const productDetails = useGetProductInformation(sku);
  const productDetailsStatus = productDetails.status;

  const details: [string, string][] = [];
  for (const key in productDetails.data) {
    const newKey = t(key);
    details.push([newKey, t(key + '_' + productDetails.data[key])]);
  }
  if (productDetails.productClass) {
    details.push([
      'ProductClass',
      t('PRODUCT_CLASS_' + productDetails.productClass),
    ]);
  }

  return {
    productDetailsStatus,
    details,
    productClass: productDetails.productClass,
  };
};
